import React from 'react'
import { Header2, Header3, Text } from '../../styles/Components'
import Button from '../Button'
import { gsColors as c } from '../../styles/Variables'

const Steps = () => {
  return (
    <div className="section-wrapper steps" id="main-content" tabIndex="0">
      <Header2>1, 2, 3 - Glam</Header2>
      <div className="steps-inner">
        <div className="step-card">
          <Header3 margin="0 0 4px 0" color={c.cobalt}>
            01
          </Header3>
          <Header3 fontSize={24} margin="0 0 12px 0">
            Book your appointment
          </Header3>
          <Text fontSize={22} lineHeight="145%" spacing="0.22">
            You choose the time and place and our pros will come right to you.
            (No booking minimums!)
          </Text>
        </div>
        <div className="step-card">
          <Header3 margin="0 0 4px 0" color={c.cobalt}>
            02
          </Header3>
          <Header3 fontSize={24} margin="0 0 12px 0">
            Create an account
          </Header3>
          <Text fontSize={22} lineHeight="145%" spacing="0.22">
            It&apos;s quick, simple, and allows you to book future appointments
            in a snap.
          </Text>
        </div>
        <div className="step-card">
          <Header3 margin="0 0 4px 0" color={c.cobalt}>
            03
          </Header3>
          <Header3 fontSize={24} margin="0 0 12px 0">
            Sit back + get glam
          </Header3>
          <Text fontSize={22} lineHeight="145%" spacing="0.22">
            Our pro(s) will arrive with everything they need to pamper you. No
            cash needed — tip is included in your total.
          </Text>
        </div>
      </div>
      <Button outline large color="#000" path="book">
        Book Now
      </Button>
    </div>
  )
}

export default Steps
